import React        from "react";
import { CPopover } from "@coreui/react";
import { isChunkLoadError } from "../helpers/lazyWithRetry";
import reportError from "../services/errorReporter";

const RELOAD_KEY = "chunk-reload-attempt";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  logError({ error, info }) {
    const styles = fontSize => ([
      'padding: 10px',
      'color: #731111',
      'background: #ededed',
      `font-size: ${fontSize}`,
    ].join(";"));

    console.log("%cErro!", styles("20px"));
    console.log(`%c
      Por favor, se o erro persistir, contate o suporte:
      suporte@meuml.com+55 (41)99123-0100

      Envie um print do conteúdo abaixo:
	    error_obj: ${JSON.stringify(error)}
	    Info: ${info}`,
	    styles("16px")
    );
  }

  componentDidCatch(error, errorInfo) {
    const isChunk = isChunkLoadError(error);
    if (isChunk) {
      const alreadyReloaded = window.sessionStorage.getItem(RELOAD_KEY) === "1";
      if (!alreadyReloaded) {
        reportError({
          type: "chunk-error-reloading",
          message: error && error.message,
          stack: error && error.stack,
          componentStack: errorInfo && errorInfo.componentStack,
        });
        window.sessionStorage.setItem(RELOAD_KEY, "1");
        window.location.reload();
        return;
      }
      window.sessionStorage.removeItem(RELOAD_KEY);
    }
    reportError({
      type: isChunk ? "chunk-error-fatal" : "react-render",
      message: error && error.message,
      stack: error && error.stack,
      componentStack: errorInfo && errorInfo.componentStack,
    });
    this.logError({ error, info: errorInfo });
    this.setState({ hasError: true, error });
  }

  render() {
    if (this.state.hasError) {
      return this.props.render || (
        <h1 className="text-danger pointer">
          <CPopover content="Houve um erro na hora de processar esta informação. Contate o suporte para obter ajuda." placement="right">
            <i className="fas fa-times-circle" />
          </CPopover>
        </h1>
      );
    }

    return this.props.children;
  }
}